import { useMemo, useState } from 'react';
import { logoPrincipal } from '../assets';
import { FiFacebook, FiInstagram, FiYoutube, FiTwitter, FiLinkedin, FiGithub, FiMail, FiPhone, FiLink } from 'react-icons/fi';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import useFirestoreCollection from '../hooks/useFirestoreCollection';
import LegalModal from './LegalModal';

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [legalView, setLegalView] = useState(null); // 'privacy' | 'terms' | 'cookies'

  const { data: socialMedia } = useFirestoreCollection('socialMedia');
  const socialLinks = socialMedia.length
    ? socialMedia
    : [
        { platform: 'facebook', url: 'https://www.facebook.com/share/1J2FRes2aK/?mibextid=wwXIfr', label: 'Facebook' },
        { platform: 'whatsapp', url: 'https://wa.me/19145071839', label: 'WhatsApp' },
        { platform: 'telegram', url: 'https://t.me/nextglobalmedia', label: 'Telegram' },
        { platform: 'youtube', url: 'https://youtube.com', label: 'YouTube' },
        { platform: 'instagram', url: 'https://www.instagram.com/nextglobalmedia.us?igsh=eDcxNWJybmFvczZn&utm_source=qr', label: 'Instagram' },
        { platform: 'tiktok', url: 'https://tiktok.com', label: 'TikTok' },
      ];

  const getSocialIcon = (platform) => {
    switch ((platform || '').toLowerCase()) {
      case 'facebook':
        return FiFacebook;
      case 'instagram':
        return FiInstagram;
      case 'youtube':
        return FiYoutube;
      case 'twitter':
        return FiTwitter;
      case 'linkedin':
        return FiLinkedin;
      case 'github':
        return FiGithub;
      case 'email':
        return FiMail;
      case 'phone':
        return FiPhone;
      case 'whatsapp':
        return FaWhatsapp;
      case 'telegram':
        return FaTelegramPlane;
      case 'tiktok':
        return SiTiktok;
      default:
        return FiLink;
    }
  };

  const openLegal = (view) => {
    setLegalView(view);
    setLegalOpen(true);
  };

  const closeLegal = () => {
    setLegalOpen(false);
    setLegalView(null);
  };

  const legalContent = useMemo(() => {
    if (legalView === 'privacy') {
      return {
        title: 'Política de Privacidad',
        body: (
          <>
            <p>En Next Global Media respetamos tu privacidad y protegemos tu información personal.</p>

            <h4>Información que recopilamos:</h4>
            <ul>
              <li>Nombre</li>
              <li>Correo electrónico</li>
              <li>Número de teléfono</li>
              <li>Información enviada a través de formularios</li>
            </ul>

            <h4>Uso de la información</h4>
            <p>Utilizamos tus datos para:</p>
            <ul>
              <li>Contactarte</li>
              <li>Brindarte información sobre nuestros servicios</li>
              <li>Enviarte ofertas o contenido relacionado (si aplica)</li>
            </ul>

            <p>No vendemos, alquilamos ni compartimos tu información con terceros.</p>

            <h4>Herramientas</h4>
            <p>Podemos utilizar herramientas como:</p>
            <ul>
              <li>Google Analytics</li>
              <li>Meta (Facebook/Instagram Ads)</li>
              <li>Plataformas de automatización</li>
            </ul>

            <p>Estas herramientas pueden recopilar datos anónimos para mejorar la experiencia del usuario.</p>
            <p>Al usar este sitio, aceptas esta política de privacidad.</p>
          </>
        ),
      };
    }

    if (legalView === 'terms') {
      return {
        title: 'Términos y Condiciones',
        body: (
          <>
            <p>Al acceder a este sitio web, aceptas cumplir con los siguientes términos:</p>
            <ul>
              <li>El contenido del sitio es propiedad de Next Global Media</li>
              <li>No está permitido copiar, distribuir o reproducir el contenido sin autorización</li>
              <li>Los servicios ofrecidos están sujetos a acuerdos específicos con cada cliente</li>
              <li>Los resultados pueden variar según el proyecto y factores externos</li>
            </ul>

            <h4>Next Global Media no se responsabiliza por:</h4>
            <ul>
              <li>Decisiones tomadas basadas en la información del sitio</li>
              <li>Problemas técnicos fuera de nuestro control</li>
            </ul>

            <p>Nos reservamos el derecho de modificar estos términos en cualquier momento.</p>
          </>
        ),
      };
    }

    if (legalView === 'cookies') {
      return {
        title: 'Política de Cookies',
        body: (
          <>
            <p>Este sitio web utiliza cookies para mejorar tu experiencia.</p>

            <p>Las cookies son pequeños archivos que se almacenan en tu dispositivo y permiten:</p>
            <ul>
              <li>Analizar el comportamiento del usuario</li>
              <li>Mejorar el rendimiento del sitio</li>
              <li>Mostrar contenido personalizado</li>
            </ul>

            <h4>Utilizamos herramientas como:</h4>
            <ul>
              <li>Google Analytics</li>
              <li>Pixel de Meta</li>
            </ul>

            <p>Puedes aceptar, rechazar o eliminar las cookies desde la configuración de tu navegador.</p>
            <p>Al continuar navegando en este sitio, aceptas el uso de cookies.</p>
          </>
        ),
      };
    }

    // (opcional) Aviso legal como fallback (si legalView es null)
    return {
      title: 'Aviso Legal',
      body: (
        <>
          <p>
            Next Global Media es una agencia de marketing digital enfocada en ofrecer servicios de branding, desarrollo
            web, marketing digital, automatización e inteligencia artificial.
          </p>

          <p>Al acceder y utilizar este sitio web, aceptas las condiciones aquí descritas.</p>

          <p>
            La información proporcionada en este sitio tiene fines informativos y comerciales. Next Global Media no
            garantiza resultados específicos, ya que estos pueden variar según cada proyecto, mercado y ejecución.
          </p>

          <p>Nos reservamos el derecho de modificar el contenido del sitio en cualquier momento sin previo aviso.</p>

          <h4>Contacto</h4>
          <ul>
            <li>📧 Nataly@nextglobalmedia.com</li>
            <li>📍 New York, United States</li>
          </ul>
        </>
      ),
    };
  }, [legalView]);

  return (
    <footer
      className="
        py-24 border-t border-orange-500
        bg-[#000000]/80 dark:bg-[#000000]/80
        backdrop-blur-md
        relative overflow-hidden
      "
    >
      {/* ✅ BACKGROUND logoPrincipal centrado y a todo el ancho (más visible) */}
      <div className="absolute inset-0 pointer-events-none z-0 flex items-center justify-center">
        <img
          src={logoPrincipal}
          alt=""
          className="
            w-[1200px] max-w-[140vw] h-auto
            opacity-[0.14] dark:opacity-[0.18]
            object-contain
          "
          style={{ filter: 'grayscale(1) contrast(1.25)' }}
        />
      </div>

      {/* ✅ overlay */}
      <div className="absolute inset-0 pointer-events-none z-0 bg-black/20 dark:bg-black/20" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-20 mb-20">
          <div className="col-span-1 md:col-span-2">
            <img alt="Next Global Media Full Logo" className="h-14 mb-10 mix-blend-multiply" src={logoPrincipal} />

            <p className="text-slate-600 dark:text-slate-300 max-w-sm mb-12 text-lg font-light leading-relaxed">
              Hacemos que tu marca avance con estrategia, creatividad y tecnología. Nuestro objetivo es que tu negocio
              crezca, destaque y llegue más lejos.
            </p>

            <div className="flex gap-6">
              {socialLinks.map((social) => {
                const Icon = getSocialIcon(social.icon || social.platform);
                return (
                  <a
                    key={social.id || social.platform}
                    className="w-12 h-12 rounded-2xl glass-card bg-slate-300/90 flex items-center justify-center hover:bg-slate-900 hover:text-white transition-all border border-slate-200 group"
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={social.label || social.platform}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h5 className="font-black text-orange-500 mb-10 tracking-[0.3em] uppercase text-xs">Agencia</h5>
            <ul className="space-y-6 text-slate-600 dark:text-slate-100 text-sm font-bold">
              <li>
                <a className="hover:text-orange-500 transition-colors uppercase tracking-widest" href="#portfolio">
                  Galería
                </a>
              </li>
              <li>
                <a className="hover:text-orange-500 transition-colors uppercase tracking-widest" href="#services">
                  Servicios
                </a>
              </li>
            </ul>
          </div>

          {/* ✅ LEGAL -> botones abren modal */}
          <div>
            <h5 className="font-black text-orange-500 mb-10 tracking-[0.3em] uppercase text-xs">Legal</h5>
            <ul className="space-y-6 text-slate-300 text-sm font-bold">
              <li>
                <button
                  type="button"
                  onClick={() => openLegal('privacy')}
                  className="hover:text-orange-500 transition-colors uppercase tracking-widest"
                >
                  Privacidad
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openLegal('terms')}
                  className="hover:text-orange-500 transition-colors uppercase tracking-widest"
                >
                  Términos
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openLegal('cookies')}
                  className="hover:text-orange-500 transition-colors uppercase tracking-widest"
                >
                  Cookies
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-12 border-t border-orange-500">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            <div className="text-center md:text-left">
              <p className="text-sm text-slate-600 dark:text-slate-100 font-light tracking-wide">
                2024 NEXT GLOBAL MEDIA. ALL RIGHTS RESERVED.
              </p>
            </div>
          </div>
        </div>
      </div>

      <LegalModal open={legalOpen} title={legalContent.title} onClose={closeLegal}>
        {legalContent.body}
      </LegalModal>
    </footer>
  );
}